module.exports = __webpack_public_path__ + "assets/d2a444f3de75af05734e63dd11193c35.svg";